import React from 'react';
import { type PropsWithChildren } from 'react';

import SwitchCase from 'components/Common/SwitchCase';
import type { NavigateProps } from 'react-router-dom';
import { Navigate, useLocation } from 'react-router-dom';
import { LoginStorage } from 'shared/lib';

const LoginRequired = ({
  children,
  to = '/',
  state,
  relative,
}: PropsWithChildren<Omit<NavigateProps, 'to'> & { to?: NavigateProps['to'] }>) => {
  const location = useLocation();
  // 로그인 후 원래 가려던 곳으로 복귀할 수 있게 목적지를 state로 넘긴다(로그인 페이지가 state.from 사용).
  const redirectState = state ?? { from: `${location.pathname}${location.search}` };
  return (
    <SwitchCase
      value={LoginStorage.isLogin()}
      caseBy={{
        true: <>{children}</>,
        false: <Navigate to={to} replace state={redirectState} relative={relative} />,
      }}
    />
  );
};

export default LoginRequired;
